export enum SuggestedInsuranceSelectionStatus {
  INCLUDED = 'INCLUDED',
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED'
}
